import React from 'react';
import { Provider } from 'react-redux';
import store from './store/store';
import AppInit from './infra/AppInit/AppInit';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './styles/global.scss';
import { environment } from './environment';
function App() {
  return (
    <Provider store={store}>
      <Router basename={environment.baseUrl}>
        <Routes>
          <Route path={'*'} element={<AppInit />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
